"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = exports.CSS = exports.MDL = void 0;
var theme_1 = require("../../components/theme");
var theme_palette_1 = require("../../components/theme.palette");
var dashboard_table_style_1 = require("./dashboard.table.style");
//these colours are on the advice of marketing team.
var orangeFull = 'rgba(255, 131, 0, 1)';
//const orangeTrans = 'rgba(255, 131, 0, .1)';
var redFull = 'rgba(224, 69, 4, 1)';
//const redTrans = 'rgba(224, 69, 4, .1)';
//const yellowFull = 'rgba(255, 198, 41, 1)';
//const yellowTrans = 'rgba(255, 198, 41, .1)';
var greyFull = 'rgba(208, 207, 205, 1)';
var greyTrans = 'rgba(208, 207, 205, .25)';
exports.MDL = {
    button: 'mdl-button',
    title: 'mdl-layout-title',
    spacer: 'mdl-layout-spacer',
    drawer: {
        button: 'mdl-layout__drawer-button'
    }
};
exports.CSS = {
    container: 'c-Dashboard',
    title: 'c-Dashboard__title',
    message: 'c-Dashboard__message',
    tableCell: 'c-Dashboard__TableCell',
    tableCellFaint: 'c-Dashboard__TableCell--faint',
    tableCellGhost: 'c-Dashboard__TableCell--ghost',
    tableCellRoleActions: 'c-Dashboard__TableCellRole'
};
exports.Banner = {
    header: {
        container: 'c-Dash-Header',
        row: 'c-Dash-Header_row',
        section: 'c-Dash-Header__section'
    },
    menuButton: {
        span: 'c-Dash-Span',
        spanSelected: 'c-Dash-Span__selected'
    }
};
(0, theme_1.addStyles)((_a = {},
    _a[dashboard_table_style_1.CSS.header] = (_b = {},
        _b['& .mdl-data-table__cell--non-numeric'] = {
            'white-space': 'normal'
        },
        _b),
    _a[exports.CSS.container] = (_c = {
            width: '95%',
            margin: 'auto',
            'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
            'padding-bottom': '5px'
        },
        _c["& .".concat(dashboard_table_style_1.CSS.container)] = (_d = {
                border: 0,
                'table-layout': 'fixed',
                '& th': {
                    position: 'sticky',
                    top: '0',
                    'z-index': '10',
                    color: 'black'
                }
            },
            _d['& thead'] = (_e = {},
                _e['& th'] = {
                    width: '100%',
                    'background-color': greyFull
                },
                _e['& .execHeader1'] = {
                    'background-color': redFull,
                    width: '100%'
                },
                _e['& .execHeader0'] = {
                    'background-color': orangeFull,
                    width: '100%'
                },
                _e['& td:first-of-type, & th:first-of-type'] = {
                    width: 'min-content',
                    'min-width': 'min-content',
                    'background-color': greyFull
                },
                _e['& td:nth-of-type(2), & th:nth-of-type(2)'] = {
                    width: '250px',
                    'white-space': 'normal',
                    'background-color': greyFull
                },
                _e),
            _d['& td'] = {},
            _d['& td:first-of-type, & th:first-of-type'] = {
                width: 'min-content',
                'min-width': 'min-content'
            },
            _d['& td:nth-of-type(2), & th:nth-of-type(2)'] = {
                width: '250px',
                'white-space': 'normal'
            },
            _d['& .execHeader1'] = {
                'background-color': greyTrans,
                '& span': {
                    'background-color': 'rgba(0,0,0,0)'
                }
            },
            _d['& .execHeader0'] = {
                '& span': {
                    'background-color': 'rgba(0,0,0,0)'
                }
            },
            _d),
        _c),
    _a[exports.CSS.title] = {
        padding: '0 ' + theme_1.DefaultTheme.space(6),
        height: theme_1.DefaultTheme.space(12),
        'line-height': theme_1.DefaultTheme.space(12),
        display: 'flex',
        '& h6': {
            margin: 0,
            'line-height': theme_1.DefaultTheme.space(12)
        }
    },
    _a[exports.CSS.message] = {
        padding: theme_1.DefaultTheme.space(6)
    },
    _a[exports.CSS.tableCellFaint] = {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a["".concat(dashboard_table_style_1.CSS.row, ":hover .").concat(exports.CSS.tableCellGhost)] = {
        visibility: 'visible'
    },
    _a[exports.CSS.tableCellGhost] = {
        visibility: 'hidden'
    },
    _a[exports.CSS.tableCellRoleActions] = {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'space-between',
        width: '100%'
    },
    _a[exports.Banner.menuButton.span] = {
        margin: "0 ".concat(theme_1.DefaultTheme.space(2)),
        'font-weight': theme_1.DefaultTheme.font.weight.normal,
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    _a[exports.Banner.menuButton.spanSelected] = {
        margin: "0 ".concat(theme_1.DefaultTheme.space(2)),
        color: "rgb(".concat(theme_palette_1.ColorPaletteOrange.C300, ")"),
        'font-weight': theme_1.DefaultTheme.font.weight.normal,
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    _a[exports.Banner.header.container] = {
        height: theme_1.DefaultTheme.space(10),
        'min-height': theme_1.DefaultTheme.space(10),
        width: '100%'
    },
    _a[exports.Banner.header.row] = (_f = {
            display: 'flex',
            'flex-direction': 'row',
            'align-items': 'center',
            height: theme_1.DefaultTheme.space(10),
            'padding-left': theme_1.DefaultTheme.space(14),
            'padding-right': theme_1.DefaultTheme.space(2),
            'min-height': theme_1.DefaultTheme.space(10),
            color: "rgb(".concat(theme_palette_1.WHITE, ")")
        },
        _f["& .".concat(exports.MDL.title)] = {
            'white-space': 'nowrap',
            'margin-right': theme_1.DefaultTheme.space(2)
        },
        _f['& i'] = {},
        _f),
    _a[exports.Banner.header.section] = {
        display: 'flex',
        flex: 1,
        'align-items': 'center'
    },
    _a));
//# sourceMappingURL=dashboard.style.js.map